import type { IAppFeature, IFormattedAppFeature } from '~/types/app-feature'
import type { DeviceType } from '~/types/device-type'

export const formatFeatures = (features: IAppFeature): IFormattedAppFeature[] =>
  Object.entries(features).reduce((prev, [appKey, featuresByDeviceType]) => {
    Object.entries(featuresByDeviceType).forEach(([deviceType, features]) => {
      Object.values(features).forEach((feature) => {
        prev.push({
          appKey: appKey,
          deviceType: deviceType as DeviceType,
          id: feature.id,
        })
      })
    })
    return prev
  }, [] as IFormattedAppFeature[])
